import {
  Text,
  View,
  ScrollView,
  TouchableOpacity,
  TouchableWithoutFeedback,
} from "react-native";
import React, { useEffect, useRef, useState } from "react";
import { AppColors } from "../../../utility/AppColors";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { toast } from "react-toastify";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppImages } from "../../../utility/AppImages";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import { AppScreens } from "../../Utility/AppScreens";
import { getOtherUserProfile } from "../../../services/authAPI";
import Separator from "../../../Components/Separator";
import { allRankingAPI } from "../../../services/eventsAPI";
import Header from "./Common/Header";
import UserDetail from "../../../Components/profile-common-components/UserDetail";
import MyGames from "../../../Components/profile-common-components/MyGames";
import MyBelts from "../../../Components/profile-common-components/MyBelts";
import MyGamesStatus from "../../../Components/profile-common-components/MyGamesStatus";
import RankingTable from "../../../Components/profile-common-components/RankingTable";
import { ScreenBGGradientView } from "../../../common/CommonView";

export default function UserProfile({ route }) {
  const routeData = route.params;
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();
  const [userData, setUserData] = useState(null);

  const [showLoader, setShowLoader] = useState(false);
  const [userProfileData, setUserProfileData] = useState(null);
  const [accessToken, setAccessToken] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [txtBio, setTxtBio] = useState("");
  const [rankingData, setRankingData] = useState(null);
  const callUpdateBioAPI = () => {
    if (txtBio === "") {
      toast.error("Please enter bio");
      return;
    }
  };

  const [arrBeltMedalType, setArrBeltMedalType] = useState([
    {
      id: 0,
      value: 0,
      image: AppImages.icCoinBelt,
      isAvailableAmountSelected: 1,
      title: "Coin",
      isSelected: false,
      currentPrize: 0,
      sellPrice: 0,
      locked: true,
      purchaseLock: true,
      purchasedBeltAmount: 0,
      width:
        deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
          ? 69
          : 77,
      height: 69,
      popupIconWidth: 58,
    },
    {
      id: 1,
      image: AppImages.icBronzeBelt,
      title: "Bronze",
      isSelected: false,
      currentPrize: 0,
      value: 0,
      sellPrice: 0,
      purchaseLock: false,
      purchaseToken: 0,
      purchasedBeltAmount: 0,
    },
    {
      id: 2,
      image: AppImages.icSilverBelt,
      title: "Silver",
      isSelected: false,
      currentPrize: 0,
      value: 0,
      sellPrice: 0,
      purchaseLock: true,
      purchaseToken: 0,
      purchasedBeltAmount: 0,
    },
    {
      id: 3,
      image: AppImages.icGoldBelt,
      title: "Gold",
      isSelected: false,
      currentPrize: 0,
      value: 0,
      sellPrice: 0,
      purchaseLock: true,
      purchaseToken: 0,
      purchasedBeltAmount: 0,
    },
    {
      id: 4,
      image: AppImages.icPlatinumBelt,
      title: "Platinum",
      isSelected: false,
      currentPrize: 0,
      value: 0,
      sellPrice: 0,
      purchaseLock: true,
      purchaseToken: 0,
      purchasedBeltAmount: 0,
    },
  ]);

  const allRanking = async () => {
    setShowLoader(true);
    try {
      const response = await allRankingAPI();
      if (response.statusCode === 200) {
        setRankingData(response.body.rankingResult);
      }
    } catch (error) {
      setShowLoader(false);
      toast.error(error.message);
    }
  };

  useEffect(() => {
    if (userProfileData && userProfileData.belts) {
      const updatedBelts = arrBeltMedalType.map((belt) => {
        if (belt.title === "Bronze") {
          return { ...belt, value: userProfileData.belts.bronze };
        } else if (belt.title === "Silver") {
          return { ...belt, value: userProfileData.belts.silver };
        } else if (belt.title === "Gold") {
          return { ...belt, value: userProfileData.belts.gold };
        } else if (belt.title === "Platinum") {
          return { ...belt, value: userProfileData.belts.platinum };
        } else {
          return belt;
        }
      });
      setArrBeltMedalType(updatedBelts);
    }
  }, [userProfileData]);

  useEffect(() => {
    otherUserProfileAPI(routeData?.username);
    allRanking();
  }, []);

  const otherUserProfileAPI = async (username?: string) => {
    // setShowLoader(true);
    setIsLoading(true);

    try {
      const data = await getOtherUserProfile(username);
      const responseBody =
        typeof data.body === "string" ? JSON.parse(data.body) : data.body;

      setShowLoader(false);

      if (data.statusCode === 200) {
        if (responseBody) {
          setUserProfileData(responseBody);
          setTxtBio(responseBody.bio);
          setLinks({
            instagram: responseBody.socialLinks.instagramLink || "",
            youtube: responseBody.socialLinks.youtubeLink || "",
            twitch: responseBody.socialLinks.twitchLink || "",
            discord: responseBody.socialLinks.discordLink || "",
            x: responseBody.socialLinks.xLink || "",
            linkedIn: responseBody.socialLinks.linkedInLink || "",
            facebook: responseBody.socialLinks.facebookLink || "",
          });
          const belts = responseBody?.belts;
          const arr = [...arrBeltMedalType];

          // Only process belts if they exist
          if (belts) {
            arr.map((item) => {
              if (item.title === "Bronze") item.value = Number(belts.bronze || 0);
              else if (item.title === "Silver") item.value = Number(belts.silver || 0);
              else if (item.title === "Gold") item.value = Number(belts.gold || 0);
              else if (item.title === "Platinum")
                item.value = Number(belts.platinum || 0);
            });
          }
          setArrBeltMedalType(arr);
        } else {
          toast.error(responseBody.error);
        }
      } else if (data.statusCode === 400) {
        toast.error("Bad Request");
      } else if (data.statusCode > 400 && data.statusCode < 420) {
        toast.error("Unauthorized");
      } else if (data.statusCode >= 500) {
        toast.error("Internal Server Error");
      }
    } catch (error) {
      setShowLoader(false);
      console.log("Authorization failed: " + error.message);
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const scrollViewRef = useRef(null);

  const [activeTab, setActiveTab] = useState(0);
  const tabTitles = ["Profile", "Belts", "Stats", "Rank"];

  const [links, setLinks] = useState({
    instagram: "",
    youtube: "",
    twitch: "",
    discord: "",
    x: "",
    linkedIn: "",
    facebook: "",
  });
  const [searchEvent, setSearchEvent] = useState("");

  const filterRankingData = () => {
    if (!searchEvent) {
      return rankingData;
    }

    const searchTerm = searchEvent.toLowerCase();
    return rankingData.filter(
      (item) =>
        item.rank.toString().includes(searchTerm) ||
        item.userId.toLowerCase().includes(searchTerm) ||
        item.beltsWon.toString().includes(searchTerm) ||
        item.totalViews.toString().includes(searchTerm) ||
        item.giftsReceived.toString().includes(searchTerm) ||
        item.totalWinning.toString().includes(searchTerm)
    );
  };

  const filteredRankingData = filterRankingData();

  const handleSearchInput = (input) => {
    // Regular expression to allow only alphanumeric characters (letters and numbers)
    const alphanumericRegex = /^[a-zA-Z0-9]*$/;
    if (alphanumericRegex.test(input)) {
      setSearchEvent(input); // Only update state if the input is valid
    } else {
      toast.error("Only letters and numbers are allowed.");
    }
  };

  return (
    <>
      <Header
        btnSearchTapped={() => {
          navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
        }}
        btnWalletTapped={() => {}}
        btnStartTutorialTapped={() => {}}
        btnMessageTapped={() => {}}
        btnNotificationTapped={() => {}}
        btnProfileTapped={() => {}}
      />
      <TouchableWithoutFeedback>
        <View style={[styles.container]}>
          <ScreenBGGradientView />
          <View
            style={{
              flex: 1,
            }}
          >
            <Text
              style={[
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? AppFontStyle.BOLD_ANYBODY_20
                  : AppFontStyle.BOLD_ANYBODY_32,
                {
                  color: AppColors.white,
                  marginBottom: 26,
                  marginTop:
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? 20
                      : 0,
                },
              ]}
            >
              Player
            </Text>
            {deviceSize === DEVICE_SIZES.SM ||
            deviceSize === DEVICE_SIZES.XS ||
            deviceSize === DEVICE_SIZES.MD ||
            deviceSize === DEVICE_SIZES.LG ? (
              <ScrollView
                horizontal
                showsHorizontalScrollIndicator={false}
                style={{ flexGrow: 0 }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    paddingBottom: 20,
                    gap: 12,
                  }}
                >
                  {tabTitles.map((title, index) => (
                    <TouchableOpacity
                      key={index}
                      onPress={() => setActiveTab(index)}
                      style={{
                        paddingVertical: 6,
                        paddingHorizontal: 8,
                        borderWidth: 1,
                        borderColor:
                          activeTab === index
                            ? AppColors.white
                            : AppColors.gray_BABABA,
                        borderRadius: 57,
                      }}
                    >
                      <Text
                        style={[
                          AppFontStyle.MEDIUM_ANYBODY_14,
                          {
                            color:
                              activeTab === index
                                ? AppColors.white
                                : AppColors.gray_BABABA,
                          },
                        ]}
                      >
                        {title}
                      </Text>
                    </TouchableOpacity>
                  ))}
                </View>
              </ScrollView>
            ) : null}
            <ScrollView
              ref={scrollViewRef}
              showsHorizontalScrollIndicator={false}
              showsVerticalScrollIndicator={false}
              style={{ flex: 1 }}
            >
              {deviceSize === DEVICE_SIZES.SM ||
              deviceSize === DEVICE_SIZES.XS ||
              deviceSize === DEVICE_SIZES.MD ||
              deviceSize === DEVICE_SIZES.LG ? (
                <View style={{}}>
                  {activeTab === 0 && (
                    <View style={{ gap: 20, marginBottom: 20 }}>
                      {/* done */}
                      <UserDetail
                        userProfileData={userProfileData}
                        setAddLinkPopup={() => {}}
                        links={links}
                        isEditable={false}
                        isLoading={isLoading}
                      />
                      <MyGames
                        userProfileData={userProfileData}
                        isEditable={false}
                        userData={userData}
                      />
                    </View>
                  )}
                  {/* done */}
                  {activeTab === 1 && (
                    <MyBelts
                      setCornfirmPurchaseBeltModal={() => {}}
                      setSaleBeltModal={() => {}}
                      arrBeltMedalType={arrBeltMedalType}
                      setArrBeltMedalType={setArrBeltMedalType}
                      isEditable={false}
                      isLoading={isLoading}
                      setActiveTab={() => {}}
                    />
                  )}
                  {activeTab === 2 && (
                    <View style={{ marginBottom: 20 }}>
                      {/* done */}
                      <MyGamesStatus
                        userProfileData={userProfileData}
                        isLoading={isLoading}
                      />
                    </View>
                  )}

                  {activeTab === 3 && (
                    <RankingTable
                      filteredRankingData={filteredRankingData}
                      showLoader={showLoader}
                      handleSearchInput={handleSearchInput}
                      searchEvent={searchEvent}
                      userData={userData}
                      isLoading={isLoading}
                    />
                  )}
                </View>
              ) : (
                <View>
                  <View
                    style={{
                      flexDirection: "row",
                      gap: 30,
                    }}
                  >
                    <UserDetail
                      setAddLinkPopup={() => {}}
                      userProfileData={userProfileData}
                      links={links}
                      isEditable={false}
                      isLoading={isLoading}
                    />
                    <MyBelts
                      setCornfirmPurchaseBeltModal={() => {}}
                      setSaleBeltModal={() => {}}
                      arrBeltMedalType={arrBeltMedalType}
                      setArrBeltMedalType={setArrBeltMedalType}
                      isEditable={false}
                      isLoading={isLoading}
                      setActiveTab={() => {}}
                    />
                  </View>
                  <Separator
                    color={AppColors.gray_1E1E1E}
                    height={1}
                    marginTop={20}
                    marginBottom={20}
                    marginHorizontal={0}
                  />
                  <View
                    style={{
                      flexDirection: "row",
                      gap: 30,
                    }}
                  >
                    <MyGamesStatus
                      userProfileData={userProfileData}
                      isLoading={isLoading}
                    />
                    <MyGames
                      userProfileData={userProfileData}
                      isEditable={false}
                      userData={userData}
                      isLoading={isLoading}
                    />
                  </View>
                  <Separator
                    color={AppColors.gray_1E1E1E}
                    height={1}
                    marginTop={20}
                    marginBottom={20}
                    marginHorizontal={0}
                  />
                  <View style={{ zIndex: -1 }}>
                    <RankingTable
                      filteredRankingData={filteredRankingData}
                      showLoader={showLoader}
                      handleSearchInput={handleSearchInput}
                      searchEvent={searchEvent}
                      userData={userData}
                      isLoading={isLoading}
                    />
                  </View>
                </View>
              )}
            </ScrollView>
          </View>
        </View>
      </TouchableWithoutFeedback>
    </>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: "transparent",
      paddingHorizontal: "3.5%",
      paddingTop: "2.5%",
    },
    searchTextStyle: {
      backgroundColor: AppColors.appBlackColor_1e1e1e,
      borderWidth: 0,
      borderRadius: 10,
      padding: 10,
      verticalAlign: "top",
    },
    inputSearch: {
      height: "100%",
    },
    myProfileView: {
      justifyContent: "flex-start",
      gap: 20,
      flex: 1,
      flexDirection: "row",
      paddingVertical: 16,
    },
    wonBeltsView: {
      top: 10,
      width: "40%",
      borderRadius: 10,
    },
    deviceflexDirection: {
      flexDirection: "row",
    },
    beltsRankingView: {
      backgroundColor: AppColors.appBlackColor_1e1e1e,
      width: "55%",
      borderRadius: 10,
      padding: 15,
      gap: 10,
    },
    progressView: {
      width: "100%",
    },
    profileImg: {
      width: 200,
      height: 196,
      aspectRatio: 1,
      borderRadius: 12,
      // height: 180,
      // aspectRatio: 1,
      // borderRadius: 12,
    },
    beltArea: {
      width: 493,
      gap: 10,
    },
    secondLineCircle: {
      flexDirection: "row",
      justifyContent: "space-evenly",
      marginTop: 30,
      columnGap: 20,
    },
    progressCircleStyle: {
      width: "40%",
      marginVertical: 10,
    },
    modalOverlay: {
      flex: 1,
      justifyContent: "flex-start",
      alignItems: "flex-start",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },

    popoverContainer: {
      position: "absolute",
      width: 250,
      backgroundColor: "#333",
      borderRadius: 15,
      paddingLeft: 20,
      paddingRight: 20,
      paddingTop: 10,
      paddingBottom: 20,
    },
    closeButton: {
      // position: "absolute",
      // top: 0,
      // right: 10,
      alignSelf: "flex-end",
    },
    dropdownItem: {
      flexDirection: "row",
      justifyContent: "space-between",
      paddingRight: 10,
      paddingVertical: 10,
      borderBottomColor: "#444",
      borderBottomWidth: 1,
    },
    dropdownText: {
      color: "white",
      fontSize: 16,
    },
    dropdownValue: {
      color: "white",
      fontSize: 16,
    },
    searchInput: {
      backgroundColor: "#444",
      borderRadius: 10,
      padding: 10,
      marginTop: 10,
      marginBottom: 10,
      color: "white",
    },
  },
  {
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },

      inputSearch: {
        height: "100%",
      },
      myProfileView: {
        justifyContent: "flex-start",
        gap: 10,
        flex: 1,
        flexDirection: "row",
        paddingVertical: 16,
      },
      deviceflexDirection: {
        flexDirection: "column",
      },
      beltsRankingView: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        width: "100%",
        borderRadius: 10,
        padding: 15,
        gap: 10,
      },
      beltArea: {
        width: 325!,
      },
      wonBeltsView: {
        width: "100%",
        borderRadius: 10,
      },
    },
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },

      inputSearch: {
        height: "100%",
      },
      myProfileView: {
        justifyContent: "flex-start",
        gap: 10,
        flex: 1,
        flexDirection: "row",
        paddingVertical: 16,
      },
      deviceflexDirection: {
        flexDirection: "column",
      },
      beltsRankingView: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        width: "100%",
        borderRadius: 10,
        padding: 15,
        gap: 10,
      },
      wonBeltsView: {
        width: "100%",
        borderRadius: 10,
      },
      beltArea: {
        width: 400,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },

      inputSearch: {
        height: "100%",
      },

      myProfileView: {
        justifyContent: "flex-start",
        gap: 10,
        flex: 1,
        flexDirection: "row",
        paddingVertical: 16,
      },
      deviceflexDirection: {
        flexDirection: "column",
      },
      beltsRankingView: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        width: "100%",
        borderRadius: 10,
        padding: 15,
        gap: 10,
      },
      wonBeltsView: {
        width: "100%",
        borderRadius: 10,
      },
      // profileImg: {
      //   width: 118,
      //   height: 85,
      // },
      profileImg: {
        width: 128,
        height: 126,
      },
      beltArea: {
        width: 230,
      },
      progressCircleStyle: {
        width: "100%",
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },

      inputSearch: {
        height: "100%",
      },
      myProfileView: {
        justifyContent: "flex-start",
        gap: 10,
        flex: 1,
        flexDirection: "row",
        paddingVertical: 16,
      },
      deviceflexDirection: {
        flexDirection: "column",
      },
      beltsRankingView: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        width: "100%",
        borderRadius: 10,
        padding: 15,
        gap: 10,
      },
      wonBeltsView: {
        width: "100%",
        borderRadius: 10,
      },
      // profileImg: {
      //   width: 118,
      //   height: 85,
      // },
      profileImg: {
        width: 128,
        height: 126,
      },
      beltArea: {
        width: 230,
      },
      progressCircleStyle: {
        width: "100%",
      },
    },
  }
);
